import { ButtonHTMLAttributes, FC } from 'react'

type Props = {
  canPreviousPage: boolean
  canNextPage: boolean
  gotoPage: (page: number) => void
  previousPage: () => void
  nextPage: () => void
  pageCount: number
}

const PagerButton: FC<ButtonHTMLAttributes<HTMLButtonElement>> = ({
  onClick,
  disabled,
  children
}) => (
  <button
    type="button"
    className="bg-gray-600 hover:bg-green-500 hover:text-white px-3 py-2 rounded"
    onClick={onClick}
    disabled={disabled}
  >
    {children}
  </button>
)

const Buttons = ({
  canPreviousPage,
  canNextPage,
  gotoPage,
  previousPage,
  nextPage,
  pageCount
}: Props) => (
  <div className="grid grid-flow-col auto-cols-max gap-1">
    <PagerButton onClick={() => gotoPage(0)} disabled={!canPreviousPage}>
      First
    </PagerButton>

    <PagerButton onClick={() => previousPage()} disabled={!canPreviousPage}>
      Prev
    </PagerButton>

    <PagerButton onClick={() => nextPage()} disabled={!canNextPage}>
      Next
    </PagerButton>

    <PagerButton
      onClick={() => gotoPage(pageCount - 1)}
      disabled={!canNextPage}
    >
      Last
    </PagerButton>
  </div>
)

export default Buttons
